import * as marietta from '../../..';
import { Point } from '../../../core';
import { BUILDING_TYPE_MANSION, CONTROL_ACTIONMODE } from '../../Constants';
import { SVGSprite } from '../../flash/display';
import { Beam, Column, WallObject } from '../../item';
import { Stage } from '../../model';

export default class RoomMovePickerWall {
  itemInfo: marietta.webcad.collection.ItemInfoCollection;

  viewObj: Element;

  viewobjSetting: Element;

  moveFunc: Function;

  moveEndFunc: Function;

  previousPlace: marietta.core.Point;

  index: number;

  x: number;

  y: number;

  previousDot: Point;

  rotation: number = 0;

  transformMatrix: string;

  movePickerLength: number;

  hideSetting: Function;

  mouseX: any;

  mouseY: any;

  static closestWall: any[];

  static wallListFinal: any = [];

  static wall;

  static rooms: marietta.webcad.item.Room[];

  btnDelte: HTMLElement;

  public spt: SVGSprite;

  private moveMouseEvent: MouseEvent;

  _firstDot: marietta.core.Point;

  get firstDot() {
    return this._firstDot;
  }

  set firstDot(_dot: marietta.core.Point) {
    this._firstDot = _dot;
    this.updateTransforms();

    // console.log("this._firstDot",this._firstDot)
  }

  _secondDot: marietta.core.Point;

  get secondDot() {
    return this._secondDot;
  }

  set secondDot(_dot: marietta.core.Point) {
    this._secondDot = _dot;
    this.updateTransforms();
  }

  /**
   * コンストラクタ
   * */
  constructor(targetSprite: SVGSprite, _index: number) {
    this.index = _index;
    // 描画
    this.viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.viewObj.setAttribute('stroke', '#666666');
    this.viewObj.setAttribute('stroke-width', '10');
    this.viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(10, 10)));
    this.viewObj.setAttribute('fill', '#213AB2');
    this.viewObj.setAttribute('opacity', '0');
    this.viewObj.setAttribute('z-index', '0');
    this.viewObj.setAttribute('id', `itemController_wall_${_index}`);
    this.spt = new SVGSprite(this.viewObj);
    targetSprite.addChild(this.spt);
    // アクション
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      this.viewObj.addEventListener('touchstart', this.mouseClickEvent, { passive: false });
    } else {
      this.viewObj.addEventListener('mousedown', this.mouseClickEvent);
      this.viewObj.addEventListener('mouseover', this.onMouseOverMe);
      this.viewObj.addEventListener('mouseout', this.onMouseOutMe);
    }
    ua = null;
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    if (this.firstDot === undefined || this.secondDot === undefined) return;
    this.viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(this.firstDot.x, this.firstDot.y), new marietta.core.Point(this.secondDot.x, this.secondDot.y)));
  }

  /**
   * Show the picker
   */
  show() {
    this.viewObj.setAttribute('stroke', '#4584c5');
  }

  /**
   * Hide the picker
   */
  hide() {
    this.viewObj.setAttribute('stroke', '#666666');
  }

  /**
   * マウスダウンされた
   * @param MouseEvent
   */
  onMouseOverMe = () => {
    if (this.viewObj.getAttribute('stroke') !== '#4584c5') {
      this.viewObj.setAttribute('stroke', '#aed5f0');
      this.viewObj.setAttribute('opacity', '0.9');
    }
  };

  /**
   * マウスダウンされた
   * @param MouseEvent
   */
  onMouseOutMe = () => {
    if (this.viewObj.getAttribute('stroke') !== '#4584c5') {
      this.viewObj.setAttribute('opacity', '0');
      this.viewObj.setAttribute('stroke', '#666666');
    }
  };

  mouseClickEvent = (e: MouseEvent) => {
    // 選択モードのときは、バブリングさせない
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM) {
      e.stopPropagation();
    }
    // pad スマホ用タッチ座標修正
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      Stage.refreshStageMouse(<any>e);
    }
    // ドラッグの開始
    e.preventDefault();

    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
    this.mouseX = tarLayer.spt.mouseX;
    this.mouseY = tarLayer.spt.mouseY;
    this.onMouseDownMe();
  };

  /**
   * マウスダウンされた
   * @param MouseEvent
   */
  onMouseDownMe = (point = null) => {
    // removing selected tex boxes initially.
    for (let i = 0; i < RoomMovePickerWall.wallListFinal.length; i += 1) {
      if (RoomMovePickerWall.wallListFinal[i]) RoomMovePickerWall.wallListFinal[i].removeTextBoxObj();
    }
    //エラー防止
    if( !marietta.webcad.WebCADGlobal.itemManager.itemController ) return;

    const { target } = marietta.webcad.WebCADGlobal.itemManager.itemController;


    let newPoint;
    this.viewObj.setAttribute('opacity', '0.9');
    if (point == null) {
      const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
      newPoint = tarLayer.spt.localToGlobal(new Point(this.mouseX, this.mouseY));
    } else {
      newPoint = point;
    }

    if (marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerRoom) {
      if (marietta.webcad.WebCADGlobal.itemManager.currentItem instanceof marietta.webcad.item.Room) {
        (marietta.webcad.WebCADGlobal.itemManager.itemController as marietta.webcad.control.ItemControllerRoom).target.highlight(false);
        for (let i: number = 1; i <= (marietta.webcad.WebCADGlobal.itemManager.itemController as marietta.webcad.control.ItemControllerRoom).cornerPickerList.length; i += 1) {
          const itemControllerDot: any = document.getElementById(`itemController_corner_${i}`);
          itemControllerDot.setAttribute('fill', '#3598DC');
          itemControllerDot.setAttribute('stroke', '#3598DC');
        }
      }
    }
    let final;
    if (target instanceof Beam || target instanceof Column) {
      final = target.getAdjacentList(this.index - 1);
    } else if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      final = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAdjascentWallList(new marietta.core.Point(newPoint.x, newPoint.y))
    } else {
      final = target.getAdjacentList(this.index - 1);
    }

    if (final && final.wall) {
      RoomMovePickerWall.wallListFinal = final.wallTextList;
      RoomMovePickerWall.wall = final.wall.wall;
      RoomMovePickerWall.rooms = final.rooms;
      // enabling text boxes
      if (document.querySelector('.dummy_wall_input')) document.querySelector('.dummy_wall_input').remove();
      if (target) {
        if (target instanceof WallObject && point == null) {
          target.showHideWallGuide(true);
        }
      }
      for (let i = 0; i < RoomMovePickerWall.wallListFinal.length; i += 1) {
        if (RoomMovePickerWall.wallListFinal[i]) {
          RoomMovePickerWall.wallListFinal[i].showWallInput();
        }
      }
    }
    // Wall picker color change
    for (let i: number = 1; i <= this.movePickerLength; i += 1) {
      const itemControllerWall = document.getElementById(`itemController_wall_${i}`);
      if (this.viewObj !== itemControllerWall) {
        (target instanceof Beam || target instanceof Column) ? itemControllerWall.setAttribute('stroke', 'none') : itemControllerWall.setAttribute('stroke', '#666666');
      }
    }
    this.viewObj.setAttribute('stroke', '#4584c5');
    if (this.hideSetting) this.hideSetting();
    RoomMovePickerWall.closestWall = marietta.webcad.WebCADGlobal.webcad2Dmanager.getClosestWallInfo(new marietta.core.Point(newPoint.x, newPoint.y));

    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (point == null) {
      if (ua.isMobile || ua.isTablet) {
        document.addEventListener('touchmove', this.onMouseMoveMe, { passive: false });
        document.addEventListener('touchend', this.onMouseUpMe, { passive: false });
      } else {
        document.addEventListener('mousemove', this.onMouseMoveMe);
        document.addEventListener('mouseup', this.onMouseUpMe);
      }
    }
    const scope: RoomMovePickerWall = this;
    // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
    // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
    this.spt.onEnterFrame = (): void => {
      if (scope.moveMouseEvent != null) {
        scope.moveFunc(scope.moveMouseEvent, scope);
      }
    };
    ua = null;
    this.previousDot = this._firstDot.clone();
    console.log('this.previousDot', this.previousDot);
  };

  /**
   * マウスが移動した
   */
  onMouseMoveMe = (e: MouseEvent & TouchEvent) => {
    const self: RoomMovePickerWall = this;
    e.preventDefault();
    this.moveMouseEvent = e;
    for (let i = 0; i < RoomMovePickerWall.wallListFinal.length; i += 1) {
      if (RoomMovePickerWall.wallListFinal[i]) RoomMovePickerWall.wallListFinal[i].removeTextBoxObj();
    }
    // this.moveFunc( e, this );
    // pad スマホ用タッチ座標修正
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      if (e.touches.length >= 2) {
        // self.deleteMe();
        self.onMouseUpMe(e);
        return;
      }
      e.preventDefault();
      Stage.refreshStageMouse(<any>e);
    }
  };

  /**
   * マウスがUPされた
   */
  onMouseUpMe = (e: MouseEvent) => {
    e.preventDefault();

    if (this.spt.deleteEnterFrame) {
      this.moveMouseEvent = null;
    }

    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      document.removeEventListener('touchmove', this.onMouseMoveMe);
      document.removeEventListener('touchend', this.onMouseUpMe);
    } else {
      document.removeEventListener('mousemove', this.onMouseMoveMe);
      document.removeEventListener('mouseup', this.onMouseUpMe);
      // this.viewObj.addEventListener("mouseover", this.onMouseOverMe);
      // this.viewObj.addEventListener("mouseout", this.onMouseOutMe);
    }
    // this.hide() ;
    ua = null;

    if (marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerRoom
      && (marietta.webcad.WebCADGlobal.itemManager.itemController.target instanceof marietta.webcad.item.Room)) {
      (marietta.webcad.WebCADGlobal.itemManager.itemController as marietta.webcad.control.ItemControllerRoom).target.highlight(false);
    }

    // 終了の処理

    console.log('this._firstDot_up', this._firstDot);
    if (this.previousDot.x !== this._firstDot.x || this.previousDot.y !== this._firstDot.y) {
      this.moveEndFunc(e, this);
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }
  };

  /**
   * 移動 XY
   */
  move(x: number, y: number) {
    this.x = x;
    this.y = y;
  }

  /**
   * 移動X
   */
  moveX(x: number) {
    this.x = x;
  }

  /**
   * 移動Y
   */
  moveY(y: number) {
    this.y = y;
  }

  /**
   * 回転
   * @param 回転角度（度数）
   */
  rotate(angle: number) {
    this.rotation = angle;
  }

  /**
   * ピッカーdisable
   */
  disableDragger() {
    this.viewObj.removeEventListener('mousedown', this.mouseClickEvent);
    this.viewObj.removeEventListener('mouseover', this.onMouseOverMe);
    this.viewObj.removeEventListener('mouseout', this.onMouseOutMe);
    this.viewObj.setAttribute('fill', '#cccccc');
    this.viewObj.setAttribute('stroke', '#FFFFFF');
  }

  /**
   * ピッカーenable
   */
  enableDragger() {
    this.viewObj.setAttribute('fill', '#666666');
    this.viewObj.setAttribute('stroke', '#666666');
  }
}
